import { getAsync, postAsync, sleep } from './apiHelper'
const endpoint = process.env.VUE_APP_BACKEND;

export async function getDossiersByEmailAsync(email, slug) {
    if (slug !== "demo") {
        let result = await getAsync(`${endpoint}?slug=${slug}&type=checkEmail&email=${email}`);
        return result;
    }
    else {
        await sleep(500);
        return;
    }
}

export async function createAppointmentAsync(model, slug) {
    if (slug !== "demo") {
        let result = await postAsync(`${endpoint}?slug=${slug}&type=createAppointment`, model);
        return result;
    } else return await sleep(500);
}